<template>
  <div
    class="c-size-filter"
    aria-label="Select size"
    :style="filterStyle"
  >
    <button
      v-for="size in sortedOptions"
      :key="size"
      class="c-size-filter__option"
      :class="{
        'c-size-filter__option--active': isActive(size)
      }"
      role="checkbox"
      :aria-checked="isActive(size) ? true : false"
      @click="$emit('select', size)"
    >
      {{ size }}
    </button>
  </div>
</template>

<script>
import SizePickerMixin from './SizePickerMixin'
import isTablet from "@/mixins/isMobile";
export default {
  mixins: [
    SizePickerMixin,
    isTablet,
  ],
  props: {
    maxColumns: {
      type: Number,
      default: 7
    },
  },
  computed: {
    filterStyle() {
      let result = {}
      const maxColumns = this.maxColumns
      if (this.isTablet && maxColumns > 6) {
        result = {};
      } else if(maxColumns) {
        result['gridTemplateColumns'] = `repeat(${maxColumns},1fr)`
      }
      return result
    }
  },
}
</script>

<style lang="scss" scoped>
.c-size-filter {
  display: grid;
  gap: 4px;
  grid-auto-rows: minmax(rem(40px), auto);
  @include respond(tab-port) {
    grid-template-columns: repeat(6, 1fr);
  }
  &__option {
    width: 52px;
    height: 52px;
    border-radius: 100%;
    margin-bottom: rem(5px);
    background: transparent;
    @include themify($themes) {
      border: 1px solid themed('foreground', 'select');
    }

    &:hover {
      cursor: pointer;
    }

    &--active {
      @include themify($themes) {
        background-color: themed('foreground', 'select');
      }
    }
  }
}
</style>
